module.exports = __webpack_public_path__ + "img/app-qrx.e8e27a1f.png";